export default __webpack_public_path__ + "static/media/IcMessage.d9c4bc19.svg";